import { XStack, Text } from "tamagui";
import { Pressable } from "react-native";
import { X } from "@tamagui/lucide-icons";
import { truncateText } from "../utils";

type ReplyIndicatorProps = {
  replyingToContent: string;
  onCancel: () => void;
};

export const ReplyIndicator = ({
  replyingToContent,
  onCancel,
}: ReplyIndicatorProps) => {
  return (
    <XStack
      bg="$brandYellow"
      p="$2"
      px="$3"
      borderRadius="$2"
      alignItems="center"
      justifyContent="space-between"
    >
      <Text fontSize={12} flex={1} numberOfLines={1}>
        Replying to "{truncateText(replyingToContent)}"
      </Text>
      <Pressable onPress={onCancel} hitSlop={8}>
        <X size={16} color="black" />
      </Pressable>
    </XStack>
  );
};
